import BannerAdNative from './BannerAdNative.js';

class BannerAdNativeProductFallback extends BannerAdNative {
    render() {
        this._adObj = {
            native: {
                title: 'Driver du nettbutikk?',
                description:
                    'Lag annonsen på 1-2-3, vis den frem her og betal kun kr 5,- per klikk til din butikk.',
                iconImgUrl: 'https://secure.adnxs.com/imptr?id=40280&t=2',
                clickUrl:
                    'https://info.ssa.schibsted.no/?utm_medium=native&utm_source=finn&utm_campaign=SSA_Empty_Slot&utm_content=X-FINN-FALLBACK-1',
                clickTrackers: {},
                impressionTrackers: {},
                mainMedia: [
                    {
                        url:
                            'https://finncdn.no/trafikk/2017/egenreklame/ssa/1728/eks/1728_150x150.jpg',
                        weidth: 150,
                        height: 150,
                    },
                ],
                custom: {
                    price: '5',
                    type: 'product',
                    // eslint-disable-next-line
                    meta_data: 'xxx',
                    // eslint-disable-next-line
                    destination_label: 'kjøp nå',
                },
            },
        };

        const ele = document.getElementById(this._tagName);
        ele.innerHTML = this._getContent(this._adObj, this._tagName, ele);
    }
}

export default BannerAdNativeProductFallback;



// WEBPACK FOOTER //
// ./services/banner2/types/BannerAdNativeProductFallback.js